import React, { useEffect, useState } from "react";

import { makeStyles } from "@mui/styles";
import {
  Grid,
  TableCell,
  TableRow,
  TableBody,
  Typography,
  Paper,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import PrintIcon from "@mui/icons-material/Print";
import html2pdf from "html2pdf.js";
import { useHistory, useLocation } from "react-router-dom";
import Layout from "../../../components/layout/Layout";
import Controls from "../../../components/controls/Controls";
import Notify from "../../../components/customHelpers/Notify";
import Loading from "../../../components/customHelpers/Loading";
import Order from "../../../actions/order";
import ProductDetails from "./orderPrintProfile";
import CompanyInfo from "./companyInfo";
import OrderReceipt from "./orderReceipt";
import {
  Box,
  Checkbox,
  FormControlLabel,
  FormGroup,
  MenuItem,
  TextareaAutosize,
  TextField,
} from "@mui/material";
import Notification from "../../../components/customHelpers/Notification";
import { isAuth } from "../../../actions/auth";
import Assigntff from "./assignToUser";
import Popup from "../../../components/customHelpers/Popup";
import { formatNumber, getTimestamp } from "../../../utils/utils";
import useTable from "../../../components/customHelpers/useTable";
import Norecords from "../../../components/customHelpers/Norecords";

const headCells = [
  { id: "productName", label: "Product Name" },
  { id: "store", label: "Store" },
  { id: "sku", label: "Sku" },
  { id: "quantity", label: "Quantity" },
  { id: "price", label: "Price" },
  { id: "discount", label: "Discount" },
  { id: "totalPrice", label: "Total Price" },
  { id: "updatedAt", label: "Date" },
  { id: "Shipped", label: "Shipped", disableSorting: true },
];

const useStyles = makeStyles((theme) => ({
  "@media print": {
    ".shipped-column": {
      display: "none",
    },
    ".remark-field": {
      display: "none",
    },
  },
}));

const ShipmentDetailPage = () => {
  const classes = useStyles();
  const history = useHistory();
  const { NotifyMessage, notify, setNotify } = Notify();
  const [isPercentDiscount, setIsPercentDiscount] = useState(true);
  const { viewOrder, updateOrderStatus, updateOrderProductsStatus } = Order();
  const [productData, setProductData] = useState(null);
  const [event, setEvent] = useState(null);
  const [tempProductLists, setTempProductLists] = useState([]);
  const [isChecked, setIsChecked] = useState([]);
  const [openPopupAssign, setOpenPopupAssign] = useState(false);
  const [productLists, setProductLists] = useState([]);
  const [orderStatus, setOrderStatus] = useState("");
  const [isPrinting, setIsPrinting] = useState(false);
  const [values, setValues] = useState({
    loading: false,
    reload: false,
    submitting: false,
  });
  const { loading, reload, submitting } = values;
  const location = useLocation();
  const value = location.pathname.split("/").filter((x) => x)[
    location.pathname.split("/").filter((x) => x).length - 1
  ];
  useEffect(() => {
    getOrderData();
  }, [value]);

  const getOrderData = () => {
    viewOrder(value).then((data) => {
      if (data.err) {
        NotifyMessage({
          message: data.err,
          type: "error",
        });
      } else if (data) {
        setValues({ ...values, loading: false });
        setProductLists(data?.orders?.orderProducts);
        const products = data?.orders?.orderProducts || [];
        setTempProductLists(products);
        setIsChecked(new Array(products.length).fill(false));
        setProductData(data?.orders);
        setPaid(data.orders?.paid);
      }
    });
  };

  useEffect(() => {
    if (productData) {
      setOrderStatus(productData.status);
    }
  }, [productData]);

  const currencies = ["Ordered"];
  if (orderStatus !== "Pending") {
    currencies.push("Ready for Shipment");
  }
  currencies.push("Pending");
  if (orderStatus === "Shipped") {
    currencies.push("Shipped");
  }

  const handleStatusChange = (event) => {
    updateOrderStatus({ status: event.target.value }, value).then((data) => {
      if (data.err) {
        NotifyMessage({
          message: data.err,
          type: "error",
        });
      } else {
        if (
          event.target.value === "Pending" ||
          event.target.value === "Ordered"
        ) {
          history.push(`/print/${value}`);
        }
        setOrderStatus(event.target.value);
        NotifyMessage({
          message: "Order Status Successfully updated",
          type: "success",
        });
        getOrderData();
      }
    });
  };

  const [paid, setPaid] = useState("");
  const [unpaid, setUnpaid] = useState("");

  const handlePaidChange = (event) => {
    const newPaid = parseFloat(event.target.value) || 0;
    setPaid(newPaid);
    const remaining = calculateTotalPrice() - newPaid;
    setUnpaid(remaining < 0 ? 0 : remaining);
  };

  const calculateTotalPrice = () => {
    let totalPrice = 0;
    if (productLists?.length > 0) {
      productLists.forEach((order) => {
        totalPrice += parseFloat(order.totalPrice) || 0;
      });
    }
    return totalPrice.toFixed(2);
  };

  const handlePrint = () => {
    setIsPrinting(true);
    setTimeout(() => {
      const input = document.getElementById("pdfContent");
      if (!input) return;
      const originalStyle = input.getAttribute("style");
      input.setAttribute("style", "font-size: 2px;");
      const timestamp = getTimestamp();
      const opt = {
        filename: `${productData?.customer.fullName}>_Sales-order_<${value}>_<${timestamp}>.pdf`,
        image: { type: "jpeg", quality: 0.98 },
        html2canvas: { scale: 2, scrollY: -window.scrollY },
        jsPDF: { unit: "in", format: "a4", orientation: "portrait" },
        pagebreak: { mode: ["avoid-all", "css", "legacy"] },
      };
      html2pdf()
        .set(opt)
        .from(input)
        .save()
        .finally(() => {
          if (originalStyle !== null) {
            input.setAttribute("style", originalStyle);
          } else {
            input.removeAttribute("style");
          }
          setIsPrinting(false);
        });
    }, 0);
  };

  const readyForShipment = (event) => {
    setEvent(event);
    setOpenPopupAssign(true);
  };

  const handleShippedChange = (index) => (event) => {
    const updatedChecked = [...isChecked];
    updatedChecked[index] = event.target.checked;
    setIsChecked(updatedChecked);
  };

  const saveShippingStatus = () => {
    setValues({ ...values, submitting: true });
    const itemsToUpdate = tempProductLists.filter(
      (_, index) => isChecked[index]
    );
    if (itemsToUpdate.length === 0) {
      NotifyMessage({
        message: "Please select at least one order product",
        type: "error",
      });
      setValues({ ...values, submitting: false });
      return null;
    }
    updateOrderProductsStatus({ items: itemsToUpdate }, value).then((data) => {
      if (data.err) {
        NotifyMessage({ message: data.err, type: "error" });
      } else {
        NotifyMessage({
          message: "Order Product status successfully updated",
          type: "success",
        });
        setIsChecked(new Array(tempProductLists.length).fill(false));
        getOrderData();
      }
      setValues({ ...values, submitting: false });
    });
  };

  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });
  const { TblContainer, TblHead, TblPagination, recordsAfterPagingAndSorting } =
    useTable(tempProductLists, headCells, filterFn);

  return (
    <Layout>
      <Typography
        variant="h6"
        sx={{ fontSize: { xs: "1.2rem", sm: "1.5rem" } }}
      >
        <ArrowBackIcon
          style={{ cursor: "pointer" }}
          onClick={() => history.push("/shipment-order")}
        />
        <span style={{ marginLeft: "6px" }}>Shipment Detail</span>
      </Typography>
      <Box
        display="flex"
        flexDirection={{ xs: "column", sm: "row" }}
        justifyContent="space-between"
        m={1}
        p={1}
        gap={1}
      >
        <Controls.Button
          text="Print"
          variant="outlined"
          startIcon={<PrintIcon />}
          className="newButton"
          onClick={handlePrint}
          sx={{ fontSize: { xs: "0.8rem", sm: "0.875rem" }, py: 1 }}
        />
        <Box display="flex" alignItems="center" gap={1}>
          <FormGroup>
            <FormControlLabel
              control={
                <Checkbox
                  checked={isPercentDiscount}
                  onChange={(e) => setIsPercentDiscount(e.target.checked)}
                  size="small"
                />
              }
              label="Print Bill From"
              sx={{
                "& .MuiFormControlLabel-label": {
                  fontSize: { xs: "0.8rem", sm: "0.875rem" },
                },
              }}
            />
          </FormGroup>
          <TextField
            id="outlined-select-currency"
            select
            disabled={isAuth()?.id !== productData?.assignTo}
            label="Select Status"
            value={orderStatus}
            onChange={(event) => {
              const newStatus = event.target.value;
              if (newStatus === "Ready for Shipment") {
                readyForShipment(event);
              } else {
                handleStatusChange(event);
              }
            }}
            sx={{
              minWidth: { xs: "120px", sm: "150px" },
              fontSize: { xs: "0.8rem", sm: "0.875rem" },
            }}
          >
            {currencies.map((option) => (
              <MenuItem key={option} value={option}>
                {option}
              </MenuItem>
            ))}
          </TextField>
        </Box>
      </Box>

      <div id="pdfContent" className="card">
        <div className="mt-4 flex flex-col lg:flex-row gap-4 lg:justify-between p-2 lg:p-0">
          <div className="flex flex-col sm:flex-row gap-4 w-full lg:auto lg:justify-start">
            <div className="w-full sm:auto">
              {productData && (
                <ProductDetails
                  product={productData}
                  getProductData={getOrderData}
                  edit="false"
                />
              )}
            </div>

            {isPercentDiscount && (
              <div className="w-full sm:auto">
                {isAuth() && (
                  <CompanyInfo
                    company={isAuth()?.staffOrganizations[0]?.organization}
                    getProductData={getOrderData}
                    edit="false"
                  />
                )}
              </div>
            )}
          </div>

          <div className="w-full lg:auto flex justify-start lg:justify-end">
            {productData && <OrderReceipt order={productData} />}
          </div>
        </div>
        <Grid container>
          <Grid item xs={12} className="card__body">
            {loading ? (
              <Loading />
            ) : (
              <Paper style={{ overflowX: "auto" }}>
                <TblContainer>
                  <TblHead />
                  <TableBody>
                    {recordsAfterPagingAndSorting().length > 0 ? (
                      recordsAfterPagingAndSorting().map((row, index) => (
                        <TableRow key={row.productName}>
                          <TableCell>{row.productName}</TableCell>
                          <TableCell>{row.store}</TableCell>
                          <TableCell>{row.sku}</TableCell>
                          <TableCell>{row.quantity}</TableCell>
                          <TableCell>{formatNumber(row.price)}</TableCell>
                          <TableCell>{row.discount}</TableCell>
                          <TableCell>{formatNumber(row.totalPrice)}</TableCell>
                          <TableCell>
                            {new Date(row?.updatedAt).toLocaleDateString()}
                          </TableCell>
                          {isAuth()?.id === productData?.assignTo && (
                            <TableCell className={classes["shipped-column"]}>
                              <Checkbox
                                checked={row.isShiped || isChecked[index]}
                                onChange={handleShippedChange(index)}
                                disabled={row.isShiped}
                              />
                            </TableCell>
                          )}
                        </TableRow>
                      ))
                    ) : (
                      <Norecords col={6} />
                    )}
                  </TableBody>
                </TblContainer>
                {!isPrinting && <TblPagination />}
              </Paper>
            )}
          </Grid>
        </Grid>
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", sm: "row" },
            alignItems: {
              xs: "stretch",
              sm: isPrinting ? "flex-end" : "flex-start",
            },
            justifyContent: { sm: isPrinting ? "flex-end" : "space-between" },
            gap: 2,
            mt: 2,
          }}
        >
          {!isPrinting && (
            <TextareaAutosize
              aria-label="minimum height"
              minRows={7}
              placeholder="Remark"
              value={productData?.remark}
              style={{
                marginTop: "15px",
                padding: "8px",
                borderRadius: "4px",
                border: "1px solid #ccc",
                resize: "both",
                fontSize: { xs: "0.9rem", sm: "1rem" },
              }}
              className={`${classes["remark-field"]} mt-4 p-2 border border-gray-300 rounded resize-both 
              w-[300px] sm:w-[400px] text-sm sm:text-base`}
            />
          )}
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: { xs: "stretch", sm: "flex-end" },
              p: 1,
              m: 1,
              bgcolor: "background.paper",
              borderRadius: 1,
              width: { xs: "100%", sm: "auto" },
            }}
          >
            {calculateTotalPrice() && (
              <Box p={1}>
                <div
                  style={{
                    marginRight: { xs: 0, sm: "35px" },
                    fontWeight: "bold",
                    fontSize: { xs: "0.9rem", sm: "15px" },
                    textAlign: { xs: "left", sm: "right" },
                  }}
                >
                  Total Price: {formatNumber(calculateTotalPrice())}
                </div>
              </Box>
            )}
            <Box p={1} display="flex" alignItems="center" gap={1}>
              <span style={{ marginRight: "10px" }}>Paid</span>
              <TextField
                disabled
                value={formatNumber(paid)}
                onChange={handlePaidChange}
                size="small"
                sx={{ width: { xs: "100%", sm: "auto" } }}
              />
            </Box>
            {calculateTotalPrice() > 0 && (
              <Box p={1} display="flex" alignItems="center" gap={1}>
                <span style={{ marginRight: "10px" }}>Balance</span>
                <TextField
                  disabled
                  value={
                    unpaid > 0
                      ? formatNumber(unpaid)
                      : formatNumber(calculateTotalPrice() - productData?.paid)
                  }
                  size="small"
                  sx={{ width: { xs: "100%", sm: "auto" } }}
                />
              </Box>
            )}
            <Box p={1}>
              {isAuth()?.id === productData?.assignTo && !isPrinting && (
                <Controls.Button
                  text="Change Into Shippment"
                  disabled={values.submitting}
                  onClick={saveShippingStatus}
                  sx={{
                    width: { xs: "100%", sm: "auto" },
                    fontSize: { xs: "0.8rem", sm: "0.875rem" },
                  }}
                />
              )}
            </Box>
          </Box>
        </Box>
      </div>
      <Notification notify={notify} setNotify={setNotify} />
      <Popup
        title="Assign User"
        openPopup={openPopupAssign}
        setOpenPopup={setOpenPopupAssign}
      >
        <Assigntff
          NotifyMessage={NotifyMessage}
          setOpenPopup={setOpenPopupAssign}
          getAllOrders={getOrderData}
          handleStatusChange={handleStatusChange}
          id={value}
          event={event}
        />
      </Popup>
    </Layout>
  );
};

export default ShipmentDetailPage;
